import axiosV3 from '@/clientAPIV3.ts'

export const sendMegaGift = async (creatorId: string) => {
    const {data} = await axiosV3.get(`/micromorgi/${creatorId}/mega-gift`)
    return data
}
